<div class="tableContainer dealertableContainer col-12">

  <div class="paginatonSection">
    <mat-paginator #marketingProgramPaginator [pageSize]="20" [pageSizeOptions]="[10, 20, 30, 50]"
                   aria-label="Select page of Marketing Program"></mat-paginator>

  </div>
  <table mat-table [dataSource]="marketingProgramDataSourceChild" multiTemplateDataRows class="matTables newLandingPageTable">

    <ng-container matColumnDef="manufacturer">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Manufacturer</th>
      <td mat-cell *matCellDef="let element" class="text-left"> {{element.manufacturer}} </td>
    </ng-container>

    <ng-container matColumnDef="program">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Program</th>
      <td mat-cell *matCellDef="let element" class="text-left"> <span  class="d-flex align-items-center justify-content-between"><span>{{element.program}}</span><span *ngIf ="element.mediaObjectId && element.mediaObjectId != 0" (click)="downloadFile(element.mediaObjectId)" class="details"><i  class="far fa-file-pdf"></i></span></span> </td>
    </ng-container>
    <ng-container matColumnDef="orderPeriod">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Order Period</th>
      <td mat-cell *matCellDef="let element" class="text-left"> {{element.orderPeriodStart | date:'MM/dd/yyyy'}} to {{element.orderPeriodEnd | date:'MM/dd/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="shipPeriod">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Ship Period </th>
      <td mat-cell *matCellDef="let element" class="text-left"> {{element.shipPeriodStart | date:'MM/dd/yyyy'}} to {{element.shipPeriodEnd | date:'MM/dd/yyyy'}}</td>
    </ng-container>


    <ng-container matColumnDef="incentive">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Incentive </th>
      <td mat-cell *matCellDef="let element" class="text-left"> {{element.incentive}} </td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Notes</th>
      <td mat-cell *matCellDef="let element" class="text-left"> {{element.notes}} </td>
    </ng-container>

    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef class="text-left"> Product</th>
      <td mat-cell *matCellDef="let element" class="text-left yellowBg"> <i [ngClass]="element.isFavoriteProduct ? 'fa fa-regular fa-star' : 'far fa-star'" style="cursor: pointer;" (click)="toggleFavoriteItem(element.itemID)"></i> {{element.productName}} </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="programColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let element; columns: programColumns;" class="example-element-row"></tr>

  </table>
  <div *ngIf="marketingProgramDataSourceChild == undefined || marketingProgramDataSourceChild?.data?.length <= 0" class="noDataMsg">
    <p class="padding-b47">No Record Found.</p>
  </div>
</div>
